import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationMarkNotificationReadArgs,
  BackendNotification,
} from 'src/types/backend';

const MUTATION = gql`
  mutation MarkNotificationRead($notificationId: ID!) {
    markNotificationRead(notificationId: $notificationId) {
      id
    }
  }
`;

type Variables = BackendMutationMarkNotificationReadArgs;
type Result = Pick<BackendNotification, 'id'>;

export const markNotificationRead = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
